import {BaseService} from './base.service';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Proposta} from '../viewModel/proposta.model';
import {ResultApi} from '../viewModel/result_api.model';
import {AssociadoService} from './associado.service';

@Injectable({ providedIn: 'root' })
export class PropostaService extends BaseService {


    constructor(private httpClient: HttpClient, private associadoService: AssociadoService) {
        super(httpClient, 'propostasite');
    }

    async httpOptionsProposta() {
        const tokenApi = await this.getToken();
        const headerParam = {
            'Content-Type': 'application/json',
            'Authorization-Api': `Bearer ${tokenApi}`,
        };
        const token = this.getTokenUsuario();

        if (token) {
            headerParam['Authorization-Cliente-Site'] = `Bearer ${token}`;
        }
        return {
            headers: new HttpHeaders(headerParam)
        };
    }

    public async calculaValores(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            return this.httpClient
                .post<any>(`${this.path()}/calcular-valores`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async inicia(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            return this.httpClient
                .post<any>(`${this.path()}/iniciar-proposta`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async buscarProposta(idProposta: number): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            return this.httpClient
                .get<any>(`${this.path()}/${idProposta}`, valueToken)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }

    public async cadastroDadosCarrinho(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();
            const proposta = this.getProposta();

            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/cadastro-dados-carrinho`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async cadastraDadosPessoais(data: any): Promise<any> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();

            return this.httpClient
                .put<Proposta>(`${this.url}/propostasite/${proposta.id}/cadastro-dados-pessoais`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async cadastroDadosProfissionais(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();
            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/cadastro-dados-profissionais`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
         return null;
        }
    }

    public async confirmacaoPropostaSite(): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();

            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/confirmacao-proposta-site?dominio=${this.domain}`, null, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async finalizarPropostaSiteDesktop(): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();
            const proposta = this.getProposta();
            const data = await this.setDataFinalizarPropostaSite(proposta);
            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/finalizar-proposta-site`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async finalizarPropostaSite(data: any, propostaId: number): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            return this.httpClient
                .put<any>(`${this.path()}/${propostaId}/finalizar-proposta-site`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async pagamentoCartaoCredito(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();
            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/pagamento-cartao-credito`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async pagamentoBoleto(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();
            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/pagamento-boleto-bancario`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async pagamentoDebitoConta(data: any): Promise<ResultApi> {
        try {
            const valueToken = await this.httpOptionsProposta();

            const proposta = this.getProposta();

            return this.httpClient
                .put<any>(`${this.path()}/${proposta.id}/pagamento-debito-conta`, data, valueToken)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public validarParametrosCalculo(diarias, pessoas, quartos) {
        const diariasLimite = 28;
        const arrPessoas = [3];
        const diariasPossiveis = [];
        const pessoasPossiveis = [];
        const quartosPossiveis = [];

        for (let i = 0; i < 15; i++) {
            for (let j = 0; j < 15; j++) {
                const quartosPP = i + j;
                const pessoasPP = (i * 2) + (j * 3);

                if (quartosPP === 0) { continue; }

                if (pessoasPP <= 15) {
                    if (diarias <= (diariasLimite / quartosPP)) {
                        arrPessoas.push(pessoasPP);
                    }
                }
            }
        }
        const pessoasReturn = arrPessoas.reduce((a, b) => {
            return Math.max(a, b);
        });

        for (let i = 2; i < pessoasReturn; i++) {
            pessoasPossiveis.push(i);
        }

        for (let i = 0; i < 15; i++) {
            for (let j = 0; j < 15; j++) {
                if (((i * 2) + (j * 3)) - pessoas === 0) {
                    quartosPossiveis.push((i + j));
                }
            }
        }

        let quartoSelecionado: any = Object.values(quartosPossiveis).filter(
            quarto => quarto.value === quartos
        );

        if (!quartoSelecionado[0] === true) {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < quartosPossiveis.length; i++) {
                quartoSelecionado = quartosPossiveis[0].value;
                break;
            }
        } else {
            quartoSelecionado = quartoSelecionado[0].value;
        }


        // Calculo Diarias

        for (let k = 3; k <= 28; k++) {
            if (quartoSelecionado === 0) { quartoSelecionado = 1; }
            const maxDiarias = Math.floor(28 / quartoSelecionado);
            if (k === 5) { continue; }
            if (k > maxDiarias) { continue; }
            diariasPossiveis.push(k);
        }


        if (quartosPossiveis.length === 0) {
            quartosPossiveis[0].value = 1;
            quartosPossiveis[0].selected = true;
        }


        return { diarias: diariasPossiveis, pessoas: pessoasPossiveis, quartos: quartosPossiveis, quartoSelecionado };
    }

    private getProposta() {
        return JSON.parse(localStorage.getItem('mtl.proposta'));
    }

    private getTokenUsuario() {
        return localStorage.getItem('montreal.cliente.token');
    }

    private async setDataFinalizarPropostaSite(proposta: any) {
        if (proposta) {
            const associado = await this.setIsAssociado(proposta.cpf);
            return {
                confirmaSenha: '9999',
                novaSenha: '9999',
                associado,
                codigoPropostaSite: proposta.id,
                mobile: false
            };
        }
        return null;
    }

    private async setIsAssociado(cpf: string) {
        let resultCpf = null;
        if (cpf) {
            resultCpf = await this.associadoService.validarExisteCpf(cpf);
            resultCpf = (resultCpf.data) ? resultCpf.data : null;
        }
        return (resultCpf) ? resultCpf.isCliente : false;
    }
}
